import { typography } from 'material-ui/styles';
import { grey600, blue600, white } from 'material-ui/styles/colors';

const smallMargin = '20px';
const mediumMargin = '40px';
const bigMargin = '60px';

const styles = {
    chip: {
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        margin: {
            margin: 4,
        },
    },
    margin: {
        top: {
            small: {
                marginTop: smallMargin,
            },
            medium: {
                marginTop: mediumMargin,
            },
            big: {
                marginTop: bigMargin,
            },
        },
        bottom: {
            small: {
                marginBottom: smallMargin,
            },
            medium: {
                marginBottom: mediumMargin,
            },
            big: {
                marginBottom: bigMargin,
            },
        },
        right: {
            small: {
                marginRight: smallMargin,
            },
            medium: {
                marginRight: mediumMargin,
            },
            big: {
                marginRight: bigMargin,
            },
        },
    },
    navigation: {
        fontSize: 15,
        fontWeight: typography.fontWeightLight,
        color: grey600,
        paddingBottom: 15,
        display: 'inline-block',
    },
    title: {
        fontSize: 24,
        fontWeight: typography.fontWeightLight,
        marginBottom: 20,
    },
    paper: {
        padding: 30,
    },
    clear: {
        clear: 'both',
    },
    list: {
        paddingBottom: 0,
        paddingTop: 0,
    },
    formButton: {
        padding: 0,
        margin: '0 5px 10px',
    },
    formButtons: {
        marginTop: '20px',
        padding: '20px',
    },
    formCheck: {
        paddingTop: '5px',
    },
    relative: {
        position: 'relative',
    },
    subHeader: {
        fontSize: 24,
        fontWeight: typography.fontWeightLight,
        backgroundColor: blue600,
        color: white,
    },
    col: {
        marginBottom: '20px',
    },
    leftContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        marginBottom: '20px',
    },
    image: {
        cover: {
            objectFit: 'cover',
        },
        contain: {
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            margin: 0,
        },
    },
    float: {
        right: {
            float: 'right',
        },
    },
    toolbar: {
        position: 'fixed',
    },
};

export default styles;



// WEBPACK FOOTER //
// src/styles/styles.js